import "index.css";

// layouts/AuthLayout.js
const FullScreenLayout = ({ children }) => (
    <div className="auth-layout">
        {children}
    </div>
);

export default FullScreenLayout;
